module.exports = __webpack_public_path__ + "static/media/mahi.6c0f12fa.png";